import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const runDesktopTimeline = (el) => {
  const stage = el.querySelector(".stage-desktop");
  const solutionsWrapper = stage.querySelector(".solutions-wrapper");
  const solutionsWrapperRect = solutionsWrapper.getBoundingClientRect();
  const solutionsWrapperHeight = solutionsWrapperRect.height;
  const solutionsHolder = stage.querySelector(".solutions-holder");
  const solutionsHolderRect = solutionsHolder.getBoundingClientRect();
  const mainSolution = stage.querySelector(".main-solution");
  const mainSolutionSize = mainSolution.getBoundingClientRect().height;
  const solutionsList = stage.querySelector(".solutions-list");
  const solutionsListRect = solutionsList.getBoundingClientRect();
  const solutionItems = stage.querySelectorAll(".solutions-list a");

  const svgBorder = stage.querySelector(".svg-border");

  svgBorder.setAttribute("viewBox", `-2 -2 ${solutionsHolderRect.width} ${solutionsHolderRect.height}`);

  const pathParts = [`M${solutionsHolderRect.width} 0`];
  const a = 22;
  const b = 22;
  pathParts.push(`H${b}`);
  pathParts.push(`C${a} 0 0 0 0 ${b}`);
  pathParts.push(`V${solutionsHolderRect.height - 4 - b}`);
  pathParts.push(
    `C0 ${solutionsHolderRect.height - 4 - a} 0 ${solutionsHolderRect.height - 4} ${b} ${
      solutionsHolderRect.height - 4
    }`,
  );
  pathParts.push(`H${solutionsHolderRect.width - b}`);

  const pathData = pathParts.join("");

  svgBorder.innerHTML = `<path d="${pathData}" stroke="#4eb3bd" stroke-width="4" fill="none" stroke-dasharray="3000" stroke-dashoffset="3000" />`;

  gsap.set(stage, { opacity: 0, pointerEvents: "none", height: stage.getBoundingClientRect().height });
  gsap.set(stage.querySelectorAll(".solution-icon"), { opacity: 0 });
  gsap.set(solutionsList, { flexBasis: `${solutionsListRect.width}px`, flexShrink: 0 });
  gsap.set(solutionsWrapper, { height: 0, opacity: 0 });
  gsap.set(solutionsHolder, { width: mainSolutionSize });
  gsap.set(mainSolution, { opacity: 0 });
  gsap.set(Array.prototype.slice.call(solutionItems, 1), { opacity: 0, xPercent: -10 });

  const timeline = gsap.timeline({
    scrollTrigger: {
      trigger: el,
      start: () => {
        const siteHeaderHeight =
          parseInt(getComputedStyle(document.documentElement).getPropertyValue("--site-header-stuck-height")) + 2;

        return `top ${siteHeaderHeight}px`;
      },
      once: true,
      markers: false,
    },
    onComplete: () => {
      gsap.set(stage, { pointerEvents: "auto", height: "auto" });
      gsap.to(svgBorder.querySelector("path"), { strokeDashoffset: 0, duration: 0.8 });
    },
  });

  timeline.to(stage, { opacity: 1, duration: 0.3 });
  timeline.to(solutionsWrapper, { height: solutionsWrapperHeight, duration: 0.3 });
  timeline.to(solutionsWrapper, { opacity: 1, duration: 0.3 }, "<90%");
  timeline.to(stage.querySelectorAll(".solution-icon"), { opacity: 1, duration: 0.5 }, "<");
  timeline.to(solutionsHolder, { width: "100%", duration: 0.5 });
  timeline.to(solutionItems, { opacity: 1, xPercent: 0, duration: 0.2, stagger: 0.2 }, "<10%");
  timeline.to(mainSolution, { opacity: 1, duration: 0.5 });
};

document.querySelectorAll(".element-solutions").forEach((el) => {
  if (window.matchMedia("(min-width: 768px)").matches) {
    runDesktopTimeline(el);
  }
});
